export default __webpack_public_path__ + "static/whatWeDo3-9fde7eda38fddb49423f462b8104627f.webp";